import script from "./nextdayTreasureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./nextdayTreasureView.vue?vue&type=script&setup=true&lang=ts"

import "./nextdayTreasureView.vue?vue&type=style&index=0&id=4334ac04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4334ac04"]])

export default __exports__